import * as $runtime from "../runtime.js";
import * as Algorithm$dNaturalSort from "../Algorithm.NaturalSort/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dFunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTraversableWithIndex from "../Data.TraversableWithIndex/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dVariant$dTag from "../Data.Variant.Tag/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidgets$dInput from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular$dExtra$dSwitch from "../Specular.Extra.Switch/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
const $Option = (tag, _1) => ({tag, _1});
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Specular$dDom$dElement.monoidProp)(Data$dFoldable.identity))();
const subscribeDyn_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeDyn_({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
});
const forWithIndex = /* #__PURE__ */ (() => {
  const $0 = Data$dTraversableWithIndex.traversableWithIndexArray.traverseWithIndex(Specular$dInternal$dRIO.applicativeRIO);
  return b => a => $0(a)(b);
})();
const sortWith = /* #__PURE__ */ Data$dArray.sortWith(/* #__PURE__ */ Data$dOrd.ordArray(Algorithm$dNaturalSort.ordSortChunk));
const OptGroupIsSymbol = {reflectSymbol: () => "OptGroup"};
const SingleOptionIsSymbol = {reflectSymbol: () => "SingleOption"};
const OptGroup = value0 => $Option("OptGroup", value0);
const SingleOption = value0 => $Option("SingleOption", value0);
const toOptionIdTag = {toOptionId: Data$dVariant$dTag.toString};
const toOptionId1 = dictShow => ({toOptionId: dictShow.show});
const toOptionId = dict => dict.toOptionId;
const toOptionIdMaybe = dictToOptionId => (
  {
    toOptionId: v => {
      if (v.tag === "Nothing") { return ""; }
      if (v.tag === "Just") { return dictToOptionId.toOptionId(v._1); }
      $runtime.fail();
    }
  }
);
const optionLabel = v => {
  if (v.tag === "OptGroup") { return v._1.label; }
  if (v.tag === "SingleOption") { return v._1.label; }
  $runtime.fail();
};
const optionIndexRef = dictEq => dictShow => dictToOptionId => options => ref => Specular$dExtra$dSwitch.switchRef.switch(Specular$dFRP$dBase.functorDynamic.map(v => Specular$dRef.invariantRef.imap(k => {
  const $0 = (() => {
    if (k.tag === "Just") {
      const $0 = k._1;
      return Data$dArray.findMapImpl(
        Data$dMaybe.Nothing,
        Data$dMaybe.isJust,
        v1 => {
          if (v1._2.tag === "OptGroup") {
            const $1 = Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, option => dictEq.eq(option.key)($0), v1._2._1.options);
            if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dShow.showIntImpl(v1._1) + "/" + Data$dShow.showIntImpl($1._1)); }
            return Data$dMaybe.Nothing;
          }
          if (v1._2.tag === "SingleOption") {
            if (dictEq.eq(v1._2._1.key)($0)) { return Data$dMaybe.$Maybe("Just", Data$dShow.showIntImpl(v1._1)); }
            return Data$dMaybe.Nothing;
          }
          $runtime.fail();
        },
        Data$dFunctorWithIndex.mapWithIndexArray(Data$dTuple.Tuple)(v)
      );
    }
    if (k.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  })();
  if ($0.tag === "Nothing") { return ""; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
})(indexStr => {
  const v1 = v2 => {
    const $0 = Data$dString$dCommon.split("/")(indexStr);
    if ($0.length === 2) {
      const $1 = Data$dInt.fromString($0[0]);
      if ($1.tag === "Just") {
        const $2 = Data$dInt.fromString($0[1]);
        if ($2.tag === "Just") {
          const $3 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v, $1._1);
          if ($3.tag === "Just") {
            if ($3._1.tag === "OptGroup") {
              const $4 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, $3._1._1.options, $2._1);
              if ($4.tag === "Just") { return Data$dMaybe.$Maybe("Just", $4._1.key); }
              return Data$dMaybe.Nothing;
            }
            return Data$dMaybe.Nothing;
          }
          return Data$dMaybe.Nothing;
        }
        return Data$dMaybe.Nothing;
      }
      return Data$dMaybe.Nothing;
    }
    return Data$dMaybe.Nothing;
  };
  const $0 = Data$dInt.fromString(indexStr);
  if ($0.tag === "Just") {
    const $1 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v, $0._1);
    if ($1.tag === "Just") {
      if ($1._1.tag === "SingleOption") { return Data$dMaybe.$Maybe("Just", $1._1._1.key); }
      return v1(true);
    }
    return v1(true);
  }
  return v1(true);
})(ref))(options));
const select = dictEq => dictShow => dictToOptionId => props => options => ref => {
  const valueRef = optionIndexRef(dictEq)(dictShow)(dictToOptionId)(options)(ref);
  return Specular$dDom$dElement.el("select")([fold(props), Specular$dDom$dElement.bindValueOnChange(valueRef)])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBuilder.getParentNode)(node => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBuilder.monadReplaceBuilder.newSlot)(slot => subscribeDyn_(options$p => {
    const $0 = slot._1(Specular$dInternal$dRIO.mapImpl(v => {})(forWithIndex(options$p)(indexOutsideGroup => opt => {
      if (opt.tag === "OptGroup") {
        return Specular$dDom$dElement.el("optgroup")([
          Specular$dDom$dElement.attr("label")(opt._1.label),
          opt._1.disabled ? Specular$dDom$dElement.attr("disabled")("disabled") : Specular$dDom$dElement.monoidProp.mempty
        ])(Specular$dInternal$dRIO.mapImpl(v => {})(forWithIndex(opt._1.options)(indexInsideGroup => option => Specular$dDom$dElement.el("option")([
          option.disabled ? Specular$dDom$dElement.attr("disabled")("disabled") : Specular$dDom$dElement.monoidProp.mempty,
          Specular$dDom$dElement.attr("value")(Data$dShow.showIntImpl(indexOutsideGroup) + "/" + Data$dShow.showIntImpl(indexInsideGroup)),
          Specular$dDom$dElement.attr("data-option-id")(dictToOptionId.toOptionId(option.key))
        ])(Specular$dDom$dElement.text(option.label)))));
      }
      if (opt.tag === "SingleOption") {
        return Specular$dDom$dElement.el("option")([
          opt._1.disabled ? Specular$dDom$dElement.attr("disabled")("disabled") : Specular$dDom$dElement.monoidProp.mempty,
          Specular$dDom$dElement.attr("value")(Data$dShow.showIntImpl(indexOutsideGroup)),
          Specular$dDom$dElement.attr("data-option-id")(dictToOptionId.toOptionId(opt._1.key))
        ])(Specular$dDom$dElement.text(opt._1.label));
      }
      $runtime.fail();
    })));
    return () => {
      $0();
      const value = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(valueRef._1)();
      return Specular$dDom$dWidgets$dInput.setTextInputValue(node)(value)();
    };
  })(options))));
};
const naturalSortByLabels = /* #__PURE__ */ (() => {
  const $0 = Data$dFunctor.arrayMap(v => {
    if (v.tag === "OptGroup") {
      return $Option(
        "OptGroup",
        {...v._1, options: Data$dArray.sortWith(Data$dOrd.ordArray(Algorithm$dNaturalSort.ordSortChunk))(x => Algorithm$dNaturalSort.naturalKey(x.label))(v._1.options)}
      );
    }
    if (v.tag === "SingleOption") { return $Option("SingleOption", v._1); }
    $runtime.fail();
  });
  const $1 = sortWith(x => Algorithm$dNaturalSort.naturalKey((() => {
    if (x.tag === "OptGroup") { return x._1.label; }
    if (x.tag === "SingleOption") { return x._1.label; }
    $runtime.fail();
  })()));
  return x => $0($1(x));
})();
const mapOptions = f => Data$dFunctor.arrayMap(v => {
  if (v.tag === "OptGroup") { return $Option("OptGroup", {...v._1, options: Data$dFunctor.arrayMap(o => ({...o, key: f(o.key)}))(v._1.options)}); }
  if (v.tag === "SingleOption") { return $Option("SingleOption", {...v._1, key: f(v._1.key)}); }
  $runtime.fail();
});
const genericOption = {
  to: x => {
    if (x.tag === "Inl") { return $Option("OptGroup", x._1); }
    if (x.tag === "Inr") { return $Option("SingleOption", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "OptGroup") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "SingleOption") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const genericShow = dictGenericShow => x => dictGenericShow["genericShow'"]((() => {
  if (x.tag === "OptGroup") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
  if (x.tag === "SingleOption") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
  $runtime.fail();
})());
const showOption = dictShow => {
  const $0 = record => {
    if (record.disabled) { return "{ disabled: true, key: " + dictShow.show(record.key) + ", label: " + Data$dShow.showStringImpl(record.label) + " " + "}"; }
    return "{ disabled: false, key: " + dictShow.show(record.key) + ", label: " + Data$dShow.showStringImpl(record.label) + " " + "}";
  };
  return {
    show: genericShow((() => {
      const $1 = Data$dShow$dGeneric.genericShowConstructor((() => {
        const $1 = Data$dShow.showArrayImpl($1 => $0($1));
        return {
          genericShowArgs: v => [
            v.disabled
              ? "{ disabled: true, label: " + Data$dShow.showStringImpl(v.label) + ", options: " + $1(v.options) + " " + "}"
              : "{ disabled: false, label: " + Data$dShow.showStringImpl(v.label) + ", options: " + $1(v.options) + " " + "}"
          ]
        };
      })())(OptGroupIsSymbol);
      const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [$0(v)]})(SingleOptionIsSymbol);
      return {
        "genericShow'": v => {
          if (v.tag === "Inl") { return $1["genericShow'"](v._1); }
          if (v.tag === "Inr") { return $2["genericShow'"](v._1); }
          $runtime.fail();
        }
      };
    })())
  };
};
const functorOption = {
  map: f => m => {
    if (m.tag === "OptGroup") { return $Option("OptGroup", {...m._1, options: Data$dFunctor.arrayMap(v1 => ({...v1, key: f(v1.key)}))(m._1.options)}); }
    if (m.tag === "SingleOption") { return $Option("SingleOption", {...m._1, key: f(m._1.key)}); }
    $runtime.fail();
  }
};
const flattenOptionsWith = f => Data$dArray.concatMap(opt => {
  if (opt.tag === "SingleOption") { return [f(opt._1)]; }
  if (opt.tag === "OptGroup") { return Data$dFunctor.arrayMap(f)(opt._1.options); }
  $runtime.fail();
});
const flattenOptions = /* #__PURE__ */ Data$dArray.concatMap(v => {
  if (v.tag === "OptGroup") {
    if (v._1.disabled) { return Data$dFunctor.arrayMap(o => ({...o, disabled: true}))(v._1.options); }
    return v._1.options;
  }
  if (v.tag === "SingleOption") { return [v._1]; }
  $runtime.fail();
});
const findOption = pred => Data$dArray.findMap(v => {
  if (v.tag === "OptGroup") { return Data$dArray.find(pred)(v._1.options); }
  if (v.tag === "SingleOption") {
    if (pred(v._1)) { return Data$dMaybe.$Maybe("Just", v._1); }
    return Data$dMaybe.Nothing;
  }
  $runtime.fail();
});
const filterOptions = pred => Data$dArray.mapMaybe(v => {
  if (v.tag === "SingleOption") {
    if (pred(v._1.key)) { return Data$dMaybe.$Maybe("Just", $Option("SingleOption", v._1)); }
    return Data$dMaybe.Nothing;
  }
  if (v.tag === "OptGroup") {
    const options$p = Data$dArray.filterImpl(x => pred(x.key), v._1.options);
    if (options$p.length !== 0) { return Data$dMaybe.$Maybe("Just", $Option("OptGroup", {...v._1, options: options$p})); }
    return Data$dMaybe.Nothing;
  }
  $runtime.fail();
});
const eqOption = dictEq => {
  const eq2 = Data$dEq.eqArrayImpl(ra => rb => ra.disabled === rb.disabled && dictEq.eq(ra.key)(rb.key) && ra.label === rb.label);
  return {
    eq: x => y => {
      if (x.tag === "OptGroup") {
        if (y.tag === "OptGroup") { return x._1.disabled === y._1.disabled && x._1.label === y._1.label && eq2(x._1.options)(y._1.options); }
        return false;
      }
      if (x.tag === "SingleOption") {
        if (y.tag === "SingleOption") { return x._1.disabled === y._1.disabled && dictEq.eq(x._1.key)(y._1.key) && x._1.label === y._1.label; }
        return false;
      }
      return false;
    }
  };
};
const containsKey = dictEq => v => v1 => {
  if (v1.tag === "SingleOption") { return dictEq.eq(v1._1.key)(v); }
  if (v1.tag === "OptGroup") { return Data$dArray.anyImpl(o => dictEq.eq(o.key)(v), v1._1.options); }
  $runtime.fail();
};
const isSelectionValid = dictEq => v => v1 => {
  if (v.tag === "Just") { return Data$dArray.anyImpl(containsKey(dictEq)(v._1), v1); }
  if (v.tag === "Nothing") { return v1.length === 0; }
  $runtime.fail();
};
export {
  $Option,
  OptGroup,
  OptGroupIsSymbol,
  SingleOption,
  SingleOptionIsSymbol,
  containsKey,
  eqOption,
  filterOptions,
  findOption,
  flattenOptions,
  flattenOptionsWith,
  fold,
  forWithIndex,
  functorOption,
  genericOption,
  genericShow,
  isSelectionValid,
  mapOptions,
  naturalSortByLabels,
  optionIndexRef,
  optionLabel,
  select,
  showOption,
  sortWith,
  subscribeDyn_,
  toOptionId,
  toOptionId1,
  toOptionIdMaybe,
  toOptionIdTag
};
